<template>
    <div>
        <div v-if="data.length > 0" class="report-area">

            <div class="report-area-title-tag">{{ $t('menu.time_lapse_photo') }}</div>

            <div class="report-area-card">
                <div v-for="(videoData, idx_v) in data" :key="idx_v" class="a-camera-area text-center">

                    <div v-if="deviceInfo[ videoData.hashid ]">

                        <div>
                            <div class="device-name">
                                <i :class="$tools.style.classIcon(deviceInfo[ videoData.hashid ].type, 'block-title')"></i>
                                <span v-if="deviceInfo[ videoData.hashid ].nickname">{{ deviceInfo[ videoData.hashid ].nickname }}</span>
                                <span v-else>{{ deviceInfo[ videoData.hashid ].hashid }}</span>
                            </div>
                        </div>
                        <div>
                            <div>
                                {{ $t('n.' + deviceInfo[ videoData.hashid ].type) }}
                                {{ videoData.hashid }}
                                <span v-if="user_admin"> ( ID={{ deviceInfo[ videoData.hashid ].id }} )</span>
                            </div>
                            <div v-if="deviceInfo[ videoData.hashid ].description" v-html="deviceInfo[ videoData.hashid ].description"></div>
                        </div>

                    </div>
                    <div v-else>{{ videoData.hashid }}</div>

                    <b-row align-h="center">
                        <b-col lg=8>
                            <div :style="style_Video(videoData)">
                                <video width="100%" class="video-block" controls preload="none" :poster="videoData.cover">
                                    <source :src="videoData.url" type="video/mp4">
                                    {{ $t('other.browser_does_not_support') }}
                                </video>
                            </div>
                        </b-col>
                    </b-row>

                    <!-- <video width="100%" class="video-block" controls preload="none">
                        <source :src="videoData.url" type="video/mp4">
                        {{ $t('other.browser_does_not_support') }}
                    </video> -->
                </div>
            </div>

        </div>


    </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'

export default {
    props: {
        data: {
            type: Array,
            required: true,
        },
        deviceInfo: {
            type: Object,
            default: {},
        },
    },
    mounted ()
    {
    },
    computed: {
        ...mapState({
            'user_admin': state => state.user.is_admin,
        }),
    },
    methods: {

        style_Video (videoData)
        {
            return {
                backgroundImage: `url("${ videoData.cover }")`,
                backgroundSize: 'cover',
                marginBottom: '20px',
            }
        },

    },
}
</script>

<style lang="scss" scoped>

    .a-camera-area
    {
        margin-bottom: 30px;
    }


    .video-block
    {
        cursor: pointer;
        border-radius: 0px;
        // max-width: 800px;
        margin-bottom: -6px;
        // border: 2px solid #848383;

        // 浮水印
        // background-color: rgba(20, 25, 23, 0.8) !important;
        // background-blend-mode: lighten;
        // background-image: url("/farm/img/brand/logo3.png");
        // background-position: center 10%;
        // background-repeat: no-repeat;
        // background-size: 160px 40px;
    }

    .device-name
    {
        display: inline-block;
        font-size: 1.2rem;
        margin-right: 5px;
        i {
            color: #cea212;
        }
    }

</style>
